import {
  Dialog,
  Heading,
  YStack,
  Text,
  InlineLink,
  Paragraph,
  XStack,
  StorefrontIcon,
  CloseIcon,
  Button,
} from '@bounty/creators-design-system'

const formatUrl = (url: string) => {
  if (url.startsWith('http')) {
    return url
  }
  return `https://${url}`
}

type RetailLocationsModalProps = {
  open: boolean
  onOpenChange: (value: boolean) => void
  locations: string[]
  retailLocatorUrl?: string | null
  shopName?: string
}
export const RetailLocationsModal = ({
  shopName,
  open,
  onOpenChange,
  locations,
  retailLocatorUrl,
}: RetailLocationsModalProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      dialogContentProps={{ width: 400 }}
      customCloseComponent={
        <XStack cursor="pointer" ml="$1">
          <CloseIcon color="$neutral.500" onPress={() => onOpenChange(true)} />
        </XStack>
      }
    >
      <YStack space="$4" p="$2">
        <XStack display="flex" justifyContent="space-between">
          <StorefrontIcon color="rgba(92, 225, 230, 1)" size={24} />
        </XStack>
        <Heading mr="$5" size="$lg">
          {shopName ? `Find ${shopName} near you!` : 'In-store locations'}
        </Heading>
        {retailLocatorUrl && (
          <Paragraph>
            Pick us up at your local store so you can start creating content
            today.
          </Paragraph>
        )}
        <YStack space="$2">
          <Text size="$sm" fontWeight={'$semibold'}>
            Our Retailers:
          </Text>
          <YStack space="$2" pl="$2">
            {locations.map((l) => (
              <Text size="$sm" fontWeight={'$semibold'} key={l}>
                {l}
              </Text>
            ))}
          </YStack>
        </YStack>
        <XStack>
          {retailLocatorUrl && (
            <a
              style={{
                width: '100%',
                flex: 1,
                display: 'flex',
                textDecoration: 'none',
                flexBasis: 'max-content',
              }}
              href={retailLocatorUrl}
            >
              <Button
                size="$md"
                width="100%"
                event="Clicked Shop Now inside Modal"
              >
                Shop Now
              </Button>
            </a>
          )}
        </XStack>
      </YStack>
    </Dialog>
  )
}
